import createSvgIcon from "./utils/create_icon"

const ZoomOut = createSvgIcon(<><g fill="currentColor"><path d="M8 10a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z" /><path clipRule="evenodd" d="M3 11a8 8 0 1 1 14.32 4.906l3.387 3.387a1 1 0 0 1-1.414 1.414l-3.387-3.387A8 8 0 0 1 3 11zm8-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12z" fillRule="evenodd" /></g></>, "ZoomOut")
export default ZoomOut
